
<div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  </transition>

  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="
        flex
        items-end
        sm:items-center
        justify-center
        min-h-full
        p-4
        text-center
        sm:p-0
      ">
      <transition enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100" leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div class="
            relative
            bg-white
            rounded-md 
            text-left
            overflow-hidden
            shadow-xl
            transform
            transition-all
            sm:my-8 sm:max-w-lg sm:w-full
          ">
          <form @submit.prevent="submit" novalidate>
            <div class="mt-0 mr-4 w-full flex-1 relative">
              <div>
                <!-- publish social graphic: start -->

                <div class="overflow-hidden">
                  <div class="px-4 pt-2 pb-5 sm:px-0">
                    <!-- border-b border-gray-200 -->
                    <h3 class="
                        flex-1
                        text-sm
                        leading-6
                        text-center
                        font-medium
                        text-gray-500
                      ">
                      Social Graphic veröffentlichen
                    </h3>
                  </div>

                  <p class="w-full p-0 text-center text-xs text-brandhelfer-red">Formularaufbau wird sich noch ändern</p>

                  <div class="flex items-center space-x-3 p-4">
                    
                    <img :src="socialGraphic.thumbnail_link" class="rounded-t-lg w-44" />
                    <!-- <img src="/img/test.jpg" class="rounded-t-lg w-44" /> -->

                    <div class="flex flex-col flex-1 space-y-2">
                      <select v-model="form.social_account_id" :disabled="processing"
                        @change="form.social_account_id = $event.target.value"
                        class="mt-2 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 text-xs">
                        <option value="">-- bitte wählen --</option>
                        <option v-for="account in socialAccounts" :value="account.id" :key="account.id"
                          :selected="account.id == form.social_account_id">
                          {{ ucfirst(account.provider) }} | {{ account.name }}
                        </option>
                      </select>


                      <textarea id="text" v-model="form.text" :disabled="processing" rows="5" class="
                            shadow-sm
                            focus:ring-gray-400 focus:border-gray-400
                            mt-1
                            block
                            w-full
                            text-xs
                            border-gray-300
                            rounded-md
                          "></textarea>
                    </div>
                  </div>
                </div>

                <!-- publish social graphic: end -->
              </div>
            </div>
            <div class="
                bg-gray-50
                px-4
                py-3
                text-right
                sm:px-6
                flex
                items-center
                justify-between
              ">
              <button type="button" @click="cancel" class="
                  rounded-md
                  border border-gray-300
                  bg-white
                  py-2
                  px-4
                  text-sm
                  font-medium
                  text-gray-700
                  shadow-sm
                  hover:bg-gray-50
                  focus:outline-none focus:ring-offset-2
                " :disabled="processing"
                :class="processing ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'">
                Abbrechen
              </button>
              <submit-button :sending="processing" :validated="validated" :full-width="false">Veröffentlichen
              </submit-button>
            </div>
          </form>
        </div>
      </transition>
    </div>
  </div>
</div>
